import EmptyState from "./emptyState";

export default EmptyState;